export function formatScheduleRange(start, end, timeZone) {
  const first = new Date(start);
  const last = new Date(end);
  const zone = timeZone ? { timeZone } : {};
  const clock = new Intl.DateTimeFormat("en-US", { ...zone, hour: "numeric", minute: "2-digit", hour12: true });
  const date = new Intl.DateTimeFormat("en-US", { ...zone, month: "short", day: "numeric" });
  const offset = (value) => {
    const name = new Intl.DateTimeFormat("en-US", { ...zone, timeZoneName: "shortOffset" })
      .formatToParts(value).find((part) => part.type === "timeZoneName").value;
    return name === "GMT" ? "GMT +0" : name.replace(/^GMT([+-])/, "GMT $1");
  };
  const firstOffset = offset(first);
  const lastOffset = offset(last);
  return {
    time: `${clock.format(first)} - ${clock.format(last)}`,
    offset: firstOffset === lastOffset ? firstOffset : `${firstOffset} → ${lastOffset}`,
    date: date.format(first) === date.format(last) ? date.format(first) : `${date.format(first)} – ${date.format(last)}`,
  };
}

export function matchEndTime(match, tournament) {
  return new Date(new Date(match.scheduled_time).getTime() + (tournament.match_duration || 20) * 60000).toISOString();
}

export function buildMatchBreaks(matches, tournament) {
  const duration = (tournament.match_duration || 20) * 60000;
  const breakDuration = (tournament.break_time || 0) * 60000;
  const breaks = new Map();
  if (breakDuration <= 0) return breaks;
  const fields = new Map();
  for (const match of matches) {
    if (!match.scheduled_time || !Number.isFinite(new Date(match.scheduled_time).getTime())) continue;
    const field = match.field_id || tournament.fields?.[0]?.id || "unassigned";
    if (!fields.has(field)) fields.set(field, []);
    fields.get(field).push(match);
  }
  for (const [fieldId, fieldMatches] of fields) {
    fieldMatches.sort((a, b) => new Date(a.scheduled_time) - new Date(b.scheduled_time));
    for (let i = 0; i < fieldMatches.length - 1; i++) {
      const match = fieldMatches[i];
      const start = new Date(match.scheduled_time).getTime() + duration;
      const next = new Date(fieldMatches[i + 1].scheduled_time).getTime();
      if (next <= start) continue;
      const end = Math.min(start + breakDuration, next);
      breaks.set(match.id, {
        id: `break-${match.id}`, fieldId,
        start: new Date(start).toISOString(), end: new Date(end).toISOString(),
        minutes: Number(((end - start) / 60000).toFixed(1)),
      });
    }
  }
  return breaks;
}
